import cannectLoading from 'assets/gifs/cannect-loading.gif'
import Text from '../Text'
import * as Styles from './styles'

interface propsLoading {
  loading: boolean
}

function Loading({ loading }: propsLoading) {
  return (
    <span>
      {loading && (
        <Styles.Overlay>
          <Styles.Container>
            <img src={cannectLoading} alt="" width="250px" height="250px" />
            <Text type="md" color="primary" bold>
              CARREGANDO...
            </Text>
          </Styles.Container>
        </Styles.Overlay>
      )}
    </span>
  )
}

export default Loading
